import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("common");

  const quickLinks = [
    { to: "/category/wanghong-dasai", label: t("nav.wanghongDasai") },
    { to: "/category/mingxing-bagua", label: t("nav.mingxingBagua") },
    { to: "/category/heiliaozhuizong", label: t("nav.heiliaozhuizong") },
    { to: "/category/chigua-shipin", label: t("nav.chiguaShipin") },
    { to: "/about", label: t("nav.about") },
  ];

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-2/5">
              <span className="font-heading text-3xl font-black tracking-tight text-primary-400">
                51爆料
              </span>
              <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-sm">
                {t("footer.brandIntro")}
              </p>
              <div className="flex gap-3 mt-5">
                <a
                  href="https://weibo.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a
                  href="https://www.douyin.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label="抖音"
                >
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
                <a
                  href="https://weixin.qq.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a
                  href="https://www.bilibili.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label="哔哩哔哩"
                >
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>

            <div className="lg:w-1/5">
              <h4 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-4">
                {t("footer.quickLinks")}
              </h4>
              <ul className="flex flex-col gap-2">
                {quickLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:w-2/5">
              <h4 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-4">
                {t("footer.contactUs")}
              </h4>
              <div className="flex flex-col gap-3">
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-foreground-300">{t("footer.address")}</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span className="text-sm text-foreground-300">{t("footer.phone")}</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span className="text-sm text-foreground-300">{t("footer.email")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
            <p className="text-xs text-foreground-500">{t("footer.copyright")}</p>
            <div className="flex gap-4">
              <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                {t("nav.about")}
              </Link>
              <Link to="/" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                {t("nav.home")}
              </Link>
              <Link to="/category/wanghong-dasai" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                {t("nav.wanghongDasai")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}